import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { TableData } from '@ddt-web/data-service';

import { ChildCellIndex, NestedTableConfig } from '../../models';

@Component({
	selector: 'dl-nested-table',
	templateUrl: './nested-table.component.html',
	styleUrls: ['./nested-table.component.scss'],
	animations: [
		trigger('slideInOut', [
			transition(':enter', [style({ transform: 'translateY(-100%)', opacity: 0 }), animate('400ms ease-in-out', style({ transform: 'translateY(0%)', opacity: 1 }))]),
			transition(':leave', [animate('400ms ease-in-out', style({ transform: 'translateY(-100%)', opacity: 0 }))])
		])
	]
})
export class NestedTableComponent {

	@Input() public data: TableData;

	@Input('striped') public isStriped: boolean = false;
	@Input('category-classes') public categoryColumnClass: string;
	@Input('data-classes') public dataColumnClass: string;
	@Input('expand-icon-classes') public expandIconColumnClass: string;
	@Input('icon-classes') public iconColumnClass: string;

	@Input() public colors: string[];
	@Input() public tableOptions?: NestedTableConfig;

	public expandedRowIndex: number = -1;

	public toggleChildRow(index: number): void {
		if (this.expandedRowIndex === index) {
			this.expandedRowIndex = -1;
		} else {
			this.expandedRowIndex = index;
		}
	}

	public isCellIndexMatched(applicableChildrenCellsIndices: ChildCellIndex[], parentCellIndex: number, childCellIndex: number): boolean {
		return applicableChildrenCellsIndices.some(indexObject => indexObject.parentCellIndex === parentCellIndex && indexObject.childCellIndex === childCellIndex);
	}
}
